





















































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import ClientPanel from "@/data/models/ClientPanel";
import { 
  didIresDeviceCommunicateInLast24Hours, 
  getIresDeviceCategoryFromSerialNumber, 
  getIresDeviceStatus, 
  getLastUpdateText, 
  IresDevice,
  IresDeviceCategory, 
  isIdle, 
  isInError, 
  isInStandBy, 
  isInWarning, 
  isInWarningOrError, 
  isPoweredOff } from "@/data/models/IresDevice";
import { getIresDevice } from "@/data/repository/IresDeviceRepository";
import { getBranchesOfClient, shouldHideSerialNumber } from "@/data/repository/ClientRepository";
import { getGenericDeviceDetails } from "@/data/repository/GenericDeviceRepository";
import { getDeviceAssignmentsByDeviceId } from "@/data/repository/GenericDeviceAssignmentRepository";
import { DeviceTemplate } from "@/data/models/DeviceTemplate";
import { getBranchName } from "@/data/models/Branch";
import { GenericDeviceProjectAssignment } from "@/data/models/GenericDeviceAssignment";
import { formatDateShort, timestampToDate } from "@/utils/DateFormatter";
import DeviceDetailsDialog from "./DeviceDetailsDialog.vue";
import { isDeviceDeleted } from "@/utils/DeviceManagementUtils";
import { BaseDeviceInfo } from "@/data/models/BaseDeviceInfo";
import { setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import { COLOR_HY_DRY_STATUS_ACTIVE, COLOR_HY_DRY_STATUS_ERROR, COLOR_HY_DRY_STATUS_IDLE, COLOR_HY_DRY_STATUS_INACTIVE, COLOR_HY_DRY_STATUS_WARNING } from "@/utils/colors";
import Vehicle from "@/data/models/Vehicle";
import { getVehicleById } from "@/data/repository/VehicleRepository";
import { hasCapability, DeviceCapability } from "@/data/models/DeviceCapability";
import { ComBox } from "@/data/models/ComBox";

@Component({
  components: {
    "device-details-dialog": DeviceDetailsDialog,
  }
})

export default class DeviceItem extends Vue {
  @Prop()
  deviceOverview!: DeviceOverview;

  @Prop()
  clientPanel!: ClientPanel;

  @Prop()
  deviceTemplate!: DeviceTemplate;

  @Prop()
  vehicle!: Vehicle;
  
  @Prop() elevation!: number;

  @Prop()
  searchQuery!: string;

  @Prop({ default: "" })
  backgroundStyle!: string;

  @Prop({ default: false })
  forceUpdateBackgroundColor!: boolean;

  @Prop({ default: false }) isSelectionMode!: boolean;
  @Prop({ default: false }) isSelected!: boolean;

  @Ref("deviceDetailsDialog")
  deviceDetailsDialog!: DeviceDetailsDialog;

  @Watch("isSelected")
  onIsSelectedChanged() {
    this.isDeviceSelected = this.isSelected;
  }

  currentlyOpenedDeviceKey = "CurrentOpenedDevice";

  latestDate = new Date()
  iresDevice: IresDevice | null = null;

  isDeviceSelected = false;

  get shouldHideSerialNumber() {
    return shouldHideSerialNumber();
  }

  /** Phone layout (below 600 px): the row becomes a subtitle-style list row. */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /** The phone row's grey line: when (since / from - to) and, with additional info, where. */
  get phoneDeviceCaption() {
    return [this.deviceProjectTimeInfo, this.showAdditionalInfo ? this.deviceLocationText : null]
      .filter((part) => !!part)
      .join(" · ");
  }

  get panelDescriptionText() {
    return !this.shouldHideSerialNumber && this.clientPanel.inventoryNumber !== this.clientPanel.serialNumber
      ? this.clientPanel.inventoryNumber + " / " + this.clientPanel.serialNumber
      : this.clientPanel.inventoryNumber;
  }

  get deviceDescriptionText() {
    return this.deviceOverview.inventoryNumber + " - " + this.templateName;
  }

  get deviceLocationText() {
    const branchNumber = this.clientPanel
      ? this.clientPanel.branch
      : this.deviceOverview.branch

    const branch = getBranchesOfClient().find(
      (branch) => branch.branchNumber.toString() === branchNumber?.toString()
    );

    return branch
      ? this.$t("common.branch").toString() + ": " + getBranchName(branch)
      : ""
    ;
  }

  get isDeletedDevice() {
    return this.clientPanel
      ? isDeviceDeleted(this.clientPanel)
      : isDeviceDeleted(this.deviceOverview);
  }

  get showAdditionalInfo() {
    return this.clientPanel
      ? this.clientPanel.panelCurrentlyAssignedToClient && !this.isDeletedDevice
      : true;
  }

  get deviceProjectInfo() {
    let projectName = "";

    if (this.clientPanel) {
      projectName = this.clientPanel.currentProjectName 
        ? this.$t("common.currentProject", [this.clientPanel.currentProjectName]).toString()
        : this.clientPanel.lastProjectName 
          ? this.$t("common.lastProject", [this.clientPanel.lastProjectName]).toString()
          : "";
    }
    else {
      projectName = this.deviceOverview.currentlyAssigned 
        ? this.$t("common.currentProject", [this.deviceOverview.projectName]).toString()
        : this.deviceOverview.projectName
          ? this.$t("common.lastProject", [this.deviceOverview.projectName]).toString()
          : "";

      if (this.isDeletedDevice) {
        projectName = this.$t("common.deleted").toString();
      }
      else if (this.deviceOverview.availability) {
        projectName = this.$t("common.notAvailable").toString();
      }
    }

    return projectName;
  }

  get deviceProjectTimeInfo() {
    const projectName = this.deviceProjectInfo;
    let projectTimeInfo = "";

    if (!this.showAdditionalInfo) {
      return projectTimeInfo;
    }

    if (this.clientPanel) {
      if (projectName !== "") {
        const startDate = this.clientPanel.lastProjectAssignmentTimeRange?.startDate;
        const endDate = this.clientPanel.lastProjectAssignmentTimeRange?.endDate;

        const startYear = startDate ? timestampToDate(startDate)?.getFullYear() : null;
        const endYear = endDate ? timestampToDate(endDate)?.getFullYear() : null;

        if (this.clientPanel.currentProjectAssignmentTimeRange) {
          projectTimeInfo = this.$t("common.since", [formatDateShort(
            this.clientPanel.currentProjectAssignmentTimeRange?.startDate,
            false,
            true,
            undefined
          )]).toString();
        }
        else if (endDate && startDate) {
          const formattedStartDate = formatDateShort(startDate, false, true, startYear !== endYear);
          const formattedEndDate = formatDateShort(endDate, false, true, startYear !== endYear);

          if (formattedStartDate !== formattedEndDate) {
            projectTimeInfo = this.$t("allDevices.formatLastProjectTimeInfo", [
              formattedStartDate,
              formattedEndDate
            ]).toString()
          }
          else {
            projectTimeInfo = formattedStartDate;
          }
        }
      }
    }
    else {
      if (projectName !== "") {
        const startDate = this.deviceOverview.projectAssignmentTimeRange?.startDate;
        const endDate = this.deviceOverview.projectAssignmentTimeRange?.endDate;

        const startYear = startDate ? timestampToDate(startDate)?.getFullYear() : null;
        const endYear = endDate ? timestampToDate(endDate)?.getFullYear() : null;

        if (this.deviceOverview.currentlyAssigned && startDate) {
          projectTimeInfo = this.$t("common.since", [formatDateShort(
            startDate, 
            false, 
            true, 
            undefined
            )]).toString();
        }
        else if (endDate && startDate) {
          const formattedStartDate = formatDateShort(startDate, false, true, startYear !== endYear);
          const formattedEndDate = formatDateShort(endDate, false, true, startYear !== endYear);

          if (formattedStartDate !== formattedEndDate) {
            projectTimeInfo = this.$t("allDevices.formatLastProjectTimeInfo", [
              formattedStartDate,
              formattedEndDate
            ]).toString()
          }
          else {
            projectTimeInfo = formattedStartDate;
          }
        }
      }
    }

    return projectTimeInfo;
  }

  get isAssignedToProject() {
    return this.clientPanel
      ? this.clientPanel.currentProjectId !== null
      : this.deviceOverview.currentlyAssigned;
  }

  get isCurrentlyAssignedToThisClient() {
    return !this.clientPanel || this.clientPanel.panelCurrentlyAssignedToClient;
  }

  get isSelectionDisabled() {
    return this.isSelectionMode && !this.isCurrentlyAssignedToThisClient;
  }

  isDeviceDeleted(device: BaseDeviceInfo) {
    return isDeviceDeleted(device);
  }

  get lastUpdateText(): string {
    if (!this.iresDevice) {
      return "";
    }

    const iresDeviceStatus = getIresDeviceStatus(this.iresDevice);
    const ref = this.latestDate;

    if (!iresDeviceStatus || !ref || !iresDeviceStatus.createdAt) {
      return "";
    }

    return getLastUpdateText(this, ref, iresDeviceStatus, true, true);
  }

  get ringColor() {
    if (!this.iresDevice) {
      return "";
    }

    const showBlackRing =
      !isPoweredOff(this.iresDevice) &&
      didIresDeviceCommunicateInLast24Hours(this.iresDevice, this.latestDate);

    return `0 0 0 1px ${showBlackRing ? "black" : this.statusColor}`;
  }

  get statusColor() {
    if (!this.iresDevice) {
      return "";
    }

    if (this.hasPowerFail) {
      return COLOR_HY_DRY_STATUS_INACTIVE;
    }

    if (this.hasError) {
      return COLOR_HY_DRY_STATUS_ERROR;
    }

    if (this.hasWarning) {
      return COLOR_HY_DRY_STATUS_WARNING;
    }

    if (this.isInStandBy) {
      return COLOR_HY_DRY_STATUS_INACTIVE;
    }

    if (this.isIdle) {
      return COLOR_HY_DRY_STATUS_IDLE;
    }

  return COLOR_HY_DRY_STATUS_ACTIVE;
  }

  // ==================== FIRMWARE v4.0.0+ CHANGES ====================
  get doesSupportExtendedSensors() {
    if (!this.iresDevice || getIresDeviceCategoryFromSerialNumber(this.iresDevice.serialNo) === IresDeviceCategory.PANEL) {
      return false;
    }
    
    return hasCapability(this.iresDevice as ComBox, DeviceCapability.EXTENDED_SENSORS);
  }

  get hasWarningOrError(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isInWarningOrError(this.iresDevice!!, this.doesSupportExtendedSensors);
  }

  get hasError(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isInError(this.iresDevice!!, this.doesSupportExtendedSensors);
  }

  get hasWarning(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isInWarning(this.iresDevice!!, this.doesSupportExtendedSensors);
  }

  get isIdle() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isIdle(this.iresDevice!!);
  }

  get isInStandBy() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isInStandBy(this.iresDevice!!);
  }

  get hasPowerFail(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isPoweredOff(this.iresDevice!!);
  }

  get templateName() {
    return this.deviceTemplate.deviceName;
  }

  async onOpenDevice() {
    if (!this.isSelectionMode) {
      this.$emit("openDeviceDetails");

      const deviceId = this.clientPanel
          ? this.clientPanel.serialNumber
          : this.deviceOverview.id;

      setLastVisitedItem(
        deviceId,
        StorageKeyLastVisitedItemLevel.LEVEL_3, 
      );

      const titlePrefix = this.clientPanel
        ? getIresDeviceCategoryFromSerialNumber(this.clientPanel.serialNumber) === IresDeviceCategory.PANEL
          ? this.$t("common.panel").toString()
          : this.$t("common.box").toString()
        : this.$t("common.device").toString();

      const titleSuffix = this.clientPanel
        ? this.clientPanel.inventoryNumber
        : this.templateName + " - " + this.deviceOverview.inventoryNumber;

      const title = titlePrefix + " " + titleSuffix;

      const deviceDetails = this.clientPanel
        ? null
        : await getGenericDeviceDetails(this.deviceOverview.id);
      
      const deviceAssignments: GenericDeviceProjectAssignment[] = this.clientPanel
        ? []
        : await getDeviceAssignmentsByDeviceId(this.deviceOverview.id);

      let vehicle: Vehicle | null = null;
      const vehicleId = this.clientPanel?.vehicleId || this.deviceOverview?.vehicleId;
      if (vehicleId && !this.vehicle) {
        vehicle = await getVehicleById(vehicleId);
      }

      this.deviceDetailsDialog.show(title, deviceDetails, deviceAssignments, this.vehicle ?? vehicle);
    }
    else {
      if (
        !isDeviceDeleted(this.clientPanel ? this.clientPanel : this.deviceOverview) &&
        !this.isSelectionDisabled
      ) {
        this.$emit("openDeviceDetails");
      }
    }
  }

  created() {
    this.getIresDevice();
  }

  mounted() {
    this.isDeviceSelected = this.isSelected;

    const currentlyOpenedDevice = localStorage.getItem(this.currentlyOpenedDeviceKey);

    if (
      currentlyOpenedDevice === this.clientPanel?.serialNumber ||
      currentlyOpenedDevice === this.deviceOverview?.inventoryNumber  
    ) {
      localStorage.removeItem(this.currentlyOpenedDeviceKey);
      
      this.onOpenDevice();
    }
  }

  async getIresDevice() {
    if (this.clientPanel) {
      this.iresDevice = await getIresDevice(this.clientPanel.serialNumber);
    }
  }
}
